// Code review - Completed
// Documentation-Completed
import React, { useEffect, useState } from "react"; // React and state hooks
import InputText from "../ReusableComponents/InputText"; // Reusable components
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import { mainTable } from "../css/Common";
import MultiSelect from "../ReusableComponents/MultiSelect";
import MainLayout from "../components/MainLayout";
import { BindAPI, IUDAPI, BindPostAPI } from "../services/APIConnection"; // Services (API Calls)
import {
  HouseKeepingHeader,
  maintenanceHeader,
} from "../components/HeaderAttribute"; // Header Configuration
import GridPage from "../components/GridPage"; // Grid and Popup Components
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import MainPopup from "../popup-containers/MainPopup";

import toast from "react-hot-toast"; // Notifications and Loader
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import Loader from "../ReusableComponents/Loader";
import TextArea from "../ReusableComponents/TextArea";
import HouseKeepingPopup from "../popup-containers/HouseKeepingpopup";

const HouseKeeping = () => {
  // usestate values
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [popUpData, setPopUpData] = useState(null);
  const [popUpData1, setPopUpData1] = useState([]);
  const [rowIndex, setRowIndex] = useState(null);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [bindStaff, setBindStaff] = useState([]);
  const [EmloyeePosition, setBindEmployeePosition] = useState([]);
  const [Roomstatus, setRoomstatus] = useState([]);
  const [EmployeeName, setEmployeeName] = useState([]);
  const [houseTableData, sethouseTableData] = useState([]);
  const [EmployeePosition, setEmployeePosition] = useState([]);
  const [maintenanceDropdown, setMaintenanceDropdown] = useState([]);
  const [bindHouseKeepingData, setBindHouseKeepingData] = useState([]);

  const [BindHouseKeepingChildData, setBindHousekeepingChildData] = useState(
    []
  );
  const [bindMaintenanceActivity, setBindMaintenanceActivity] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [TxnHouseKeepingId, setTxnHouseKeepingId] = useState(0);
  const [errors, setErrors] = useState({
    txnHouseKeepingId: 0,
    HouseKeepingNo: "",
    date: "",
    roomType: "",
    room: "",
    roomStatus: "",
    outTime: "",
    inTime: "",
    employeePosition: "",
    employeeName: "",
    employeeID: "",
    txnMaintenanceActivityId: "",  
    // maintenancelist: "",
    description: "",
  });
  const mstclientId = sessionStorage.getItem("MstClientId");
  const [Room, setRoom] = useState(false);
  const [RoomType, setRoomType] = useState(false);
  const [bindEmployeeName, setBindEmployeeName] = useState([]);
  const [BindRoomStatus, setBindRoomStatus] = useState([]);
  const [bindRoomType, setBindRoomType] = useState([]);
  const [bindRoom, setBindRoom] = useState([]);
  const [itemTypeDropdown, setItemTypeDropdown] = useState([]);
  const [categoryDropdown, setCategoryDropdown] = useState([]);
  const [itemNameDropdown, setItemNameDropdown] = useState([]);
  const [formFieldsError, setFormFieldsError] = useState({
    txnHouseKeepingId: 0,
    HouseKeepingNo: "",
    date: "",
    roomType: "",
    room: "",
    roomStatus: "",
    outTime: "",
    inTime: "",
    employeePosition: "",
    employeeName: "",
    employeeID: "",
    txnMaintenanceActivityId: "",
    // maintenancelist: "",
    description: "",
  });


  useEffect(() => {
    const currentDate = new Date().toISOString().split("T")[0]; // YYYY-MM-DD
    setFormFields((prev) => ({ ...prev, date: currentDate }));
  }, []);

  const getToday = () => new Date().toISOString().split("T")[0];
  

  var createdBy = sessionStorage.getItem("createdBy"); // user session
  const [formFields, setFormFields] = useState({
    //Form field value
    txnHouseKeepingId: 0,
    HouseKeepingNo: "HOU",
    date: getToday(),
    roomType: "",
    room: "",
    roomStatus: "",
    outTime: "",
    inTime: "",
    employeePosition: "",
    employeeName: "",
    employeeID: "",
    txnMaintenanceActivityId: "",
    // maintenancelist: "",
    description: "",
  });

  const [filteredRooms, setFilteredRooms] = useState([]);
  // Fetch data from API and bind to table
  const BindHouseKeeping = async () => {
    debugger
    try {
      setIsLoading(true);

      const requestData = {
        mstClientId: mstclientId,
      };

      const response = await BindPostAPI(
        requestData,
        "HouseKeepingAPI/BindHouseKeeping"
      );

      if (response) {
        const data = response.data;
        console.log(response, "kavi");
        // ✅ Correct: Set the state
        setBindHouseKeepingData(data?.Table || []);

        // Dropdowns

        const RoomTypeData = response?.data?.Table1.map((item) => ({
          value: item.MstRoomTypeId,
          label: item.RoomType,
        }));
        console.log(RoomTypeData, "jen");

        const room = (data?.Table2 || []).map((item) => ({
          value: item.MstRoomMasterID,
          label: item.RoomName,
          typeId: item.MstRoomTypeId,
        }));

        const roomstatus = (data?.Table7 || []).map((item) => ({
          value: item.TxnRoomStatusId,
          label: item.RoomStatus,
        }));

        const employename = (data?.Table3 || []).map((item) => ({
          value: item.StaffId,
          label: item.StaffName,
          employeeID: item.EmployeeID,
          employeePosition: item.Position,
        }));

        const employeposition = (data?.Table4 || []).map((item) => ({
          value: item.MstPositionId,
          label: item.Position,
        }));

        const maintenance = (data?.Table6 || []).map((item) => ({
          value: item.MstMaintenanceActivityId,
          label: item.MaintenanceActivity,
        }));

        setBindHousekeepingChildData(data?.Table5 || []);
        setBindRoomType(RoomTypeData);
        setBindRoom(room);
        setBindRoomStatus(roomstatus);
        setBindEmployeeName(employename);
        setEmployeePosition(employeposition);
        setMaintenanceDropdown(maintenance);

        //setBindStaff(Staff);
      } else {
        console.error("BindHouseKeeping: Invalid response", response);
      }
    } catch (error) {
      console.error("BindHouseKeeping Error:", error);
    } finally {
      setIsLoading(false);

    }
  };
  useEffect(() => {
    BindHouseKeeping();
  }, []);

  // Time formatting from 24-hour format to 12-hour format
  const formatTimeForDisplay = (timeString) => {
    if (!timeString) return "";

    // Extract just the time part if it's a full datetime string
    const timePart = timeString.includes("T")
      ? timeString.split("T")[1]
      : timeString;

    // Remove seconds if present
    const [hours, minutes] = timePart.split(":");

    const hour = parseInt(hours, 10);
    const period = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;

    return `${hour12}:${minutes} ${period}`;
  };

  // Handle changes in input fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormFields((prev) => ({ ...prev, [name]: value }));

    if (value.trim() !== "") {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };

  // Validation for onblur
  const handleBlur = (e) => {
    const { name, value } = e.target;
    const formattedName = name.charAt(0).toUpperCase() + name.slice(1);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value.trim() === "" ? `Enter the ${formattedName}.` : "",
    }));
  };

  // Form validation
  const validateForm = () => {
    const newErrors = {};
    // if (!formFields.shiftName) newErrors.shiftName = "Enter the House Keeping No ";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handles insert, update, delete, active, and inactive operations

  const handleSubmit = async (rowIndex, flag) => {
    try {
      setSubmitBtnDisabled(true);
      setIsLoading(true);

      if (flag === 1 || flag === 2) {
        setSubmitBtnDisabled(false)
        // 🔍 Validation
        const newErrors = {
          houseKeepingNo: formFields.HouseKeepingNo
            ? ""
            : "Enter HouseKeeping No",
          date: formFields.date ? "" : "Enter Date",
          roomType: formFields.roomType ? "" : "Select Room Type",
          room: formFields.room ? "" : "Select Room",
          roomStatus: formFields.roomStatus ? "" : "Select Room Status",
          outTime: formFields.outTime ? "" : "Enter Out Time",
          inTime: formFields.inTime ? "" : "Enter In Time",
          employeeName: formFields.employeeName ? "" : "Select Employee Name",
          txnMaintenanceActivityId:
          formFields.txnMaintenanceActivityId?.length > 0
            ? ""
            : "Select at least one Maintenance Activity",

        };
        setErrors(newErrors);

        const isFormValid = Object.values(newErrors).every((err) => err === "");
        if (!isFormValid) {
          // toast.error("Please enter all mandatory fields.");
          setIsOpen(true)
          setSubmitBtnDisabled(false);
          setIsLoading(false)
          return;
        }

        // 🕒 Format Date & Time
        const currentDate = new Date().toISOString().split("T")[0];
        const outDateTime = formFields.outTime
          ? `${currentDate}T${formFields.outTime}`
          : null;
        const inDateTime = formFields.inTime
          ? `${currentDate}T${formFields.inTime}`
          : null;

        // 📦 Prepare Payload
        const payload = {
          mstClientId: parseInt(mstclientId, 10),
          txnHouseKeepingId: TxnHouseKeepingId ? TxnHouseKeepingId : 0,
          houseKeepingNo: formFields.HouseKeepingNo,
          date: formFields.date || "",
          roomType: formFields.roomType,
          room: formFields.room,
          roomStatus: formFields.roomStatus,
          outTime: outDateTime,
          inTime: inDateTime,
          employeePosition: formFields.employeePosition,
          employeeName: formFields.employeeName,
          employeeID: formFields.employeeID || "",
          txnMaintenanceActivityId: //addScreenTitle
            JSON.stringify(formFields.txnMaintenanceActivityId) || [],
          //: formFields.txnMaintenanceActivityId,
          description: formFields.description || "",
          createdBy: parseInt(createdBy, 10),
          flag,
        };

        console.log("HouseKeeping Payload =>", payload);

        // 🚀 API Call
        const response = await IUDAPI(
          payload,
          "HouseKeepingAPI/IUDHouseKeeping"
        );
        const result = response?.data?.Table?.[0]?.Result;
        console.log("API Response =>", response);
        console.log("API Response =>", response?.data?.Table);

        if (flag === 1 && result === "S") {
          toast.success("HouseKeeping data inserted successfully! 👍");
        } else if (flag === 2 && result === "M") {
          toast.success("HouseKeeping data modified successfully! 👍");
        } else {
          toast.error("Failed to save HouseKeeping data 👎");
        }
      } else {
        // 🗑️ Delete / Block / Unblock
        const data = {
          TxnHouseKeepingId: TxnHouseKeepingId ? TxnHouseKeepingId : 0,
          createdBy: parseInt(createdBy, 10),
          flag,
        };
        console.log("Delete/Block Payload =>", data);

        const response = await IUDAPI(data, "HouseKeepingAPI/IUDHouseKeeping");
        const result = response?.data?.Table?.[0]?.Result;

        if (flag === 3 && result === "D") {
          toast.success("Deleted successfully 🗑️");
        } else if (flag === 4 && result === "B") {
          toast.success("Inactivated successfully 🚫");
        } else if (flag === 5 && result === "UB") {
          toast.success("Activated successfully ✅");
        } else {
          toast.error("Operation failed 👎");
        }
      }

      setTimeout(cancel, 3000);
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      toast.error("Something went wrong 👎");
    }
  };

  var clientId = sessionStorage.getItem("MstClientId");

  // useEffect(() => {
  //   BindHouseKeepingTableData();
  // }, []);

  const BindHouseKeepingTableData = async () => {
    const data = {
      mstClientId: clientId,
    };

    const response = await BindPostAPI(
      data,
      "HouseKeepingAPI/BindHouseKeeping"
    );

    console.log("API Response:", response);
    if (response && response.data) {
      setBindHouseKeepingData(response.data.Table);
      console.log(response.data.Table);
      //setbindenquiryChildData(response.data.Table1)
    } else {
      setBindHouseKeepingData([]);
      // setbindenquiryChildData([]);
    }
  };

  const handleInputChangeForm = (e) => {
    const { name, value } = e.target;
    setFormFields((prev) => ({ ...prev, [name]: value }));
  };
  const handleAutoDropdownChange = (option, name) => {
    if (!option) {
      // If user clears the dropdown
      setFormFields((prev) => ({
        ...prev,
        [name]: "",
        employeeID: "",
        employeePosition: ""
      }));
      setErrors((prev) => ({
        ...prev,
        [name]: "",
        employeeID: "",
        employeePosition: ""
      }));
      return;
    }

    if (name === "employeeName") {
      setFormFields((prev) => ({
        ...prev,
        employeeName: option.value,              // StaffId
        employeeID: option.employeeID || "",     // auto-fill EmployeeID
        employeePosition: option.employeePosition || "" // ✅ auto-fill Position
      }));
      setErrors((prev) => ({
        ...prev,
        employeeName: "",
        employeeID: "",
        employeePosition: ""
      }));
    } else {
      setFormFields((prev) => ({ ...prev, [name]: option.value }));
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };
  const cancel = () => {
    setSubmitBtnDisabled(false)
    setVisibleAdd(false);
    setIsLoading(false);
    setVisibleTable(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    BindHouseKeeping();
    setFormFields({
      HouseKeepingNo: "HOU",
      date: getToday(),
      roomType: "",
      room: "",
      roomStatus: "",
      outTime: "",
      inTime: "",
      employeePosition: "",
      employeeName: "",
      employeeID: "",
      txnMaintenanceActivityId: [],
      // maintenancelist: "",
      description: "",
    });
    setFormFieldsError({});
    setErrors({
      HouseKeepingNo: "",
      date: "",
      roomType: "",
      room: "",
      roomStatus: "",
      outTime: "",
      inTime: "",
      employeePosition: "",
      employeeName: "",
      employeeID: "",
      txnMaintenanceActivityId: "",
      // maintenancelist: "",
      description: "",
    });
    setErrors({});
    setpopUpOpen(false);
    setRowIndex(null);
    setViewDetails(false);
    setDeleteDetails(false);
    setBlockDetails(false);
    setUnBlockDetails(false);
    //BindHouseKeepingData();
    setSubmitBtnDisabled(false);
  };
  // Opens form to add a new shift
  const handleAddHouseKeepingClick = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
  };
  // Opens form to edit an existing shift
  const handleEdit = (rowIndex) => {
    setRowIndex(rowIndex);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(true);
    setTxnHouseKeepingId(bindHouseKeepingData[rowIndex].TxnHouseKeepingId);
    const selectedRow = bindHouseKeepingData[rowIndex];
    setTxnHouseKeepingId(selectedRow.TxnHouseKeepingId);
    //  setTxnHouseKeepingId(bindHouseKeepingData[rowIndex].TxnHouseKeepingId)
    setFormFields({
      ...formFields,
      HouseKeepingNo: bindHouseKeepingData[rowIndex].HouseKeepingNo,
      date: bindHouseKeepingData[rowIndex].Date.split("T")[0],
      roomType: bindHouseKeepingData[rowIndex].RoomType,
      room: bindHouseKeepingData[rowIndex].Room,
      roomStatus: bindHouseKeepingData[rowIndex].RoomStatus,
      employeeID: bindHouseKeepingData[rowIndex].EmployeeID,
      employeeName: bindHouseKeepingData[rowIndex].EmployeeName,
      employeePosition: bindHouseKeepingData[rowIndex].EmployeePosition,
      inTime: bindHouseKeepingData[rowIndex].InTime,
      outTime: bindHouseKeepingData[rowIndex].OutTime,
      txnMaintenanceActivityId: JSON.parse(bindHouseKeepingData[rowIndex].ActivityIds1),
      description: bindHouseKeepingData[rowIndex].Description,

    });
    const filtered = bindRoom.filter(
      (r) => String(r.typeId) === String(selectedRow.RoomType)
    );
    setFilteredRooms(filtered);
  
    
  };
  // Opens popup with respective flag type (view/delete/block/unblock)
  const handlePopupAction = (rowIndex, flag) => {

    setpopUpOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
    }
    const rowData = bindHouseKeepingData[rowIndex];
    setTxnHouseKeepingId(bindHouseKeepingData[rowIndex].TxnHouseKeepingId);

    setPopUpData(rowData);
    const TestHousekeep = bindHouseKeepingData[rowIndex].TxnHouseKeepingId;

    const filtered = BindHouseKeepingChildData.filter(
      (item) => item && String(item.TxnHouseKeepingId) === String(TestHousekeep)
    );

    sethouseTableData(filtered);
  };

  const maintenanceChange = (value, name) => {

    setFormFields({
      ...formFields,
      [name]: value,
    });
  };
  const maintenanceChange1 = (updatedOptions) => {
    setFormFields({
      ...formFields,
      txnMaintenanceActivityId: updatedOptions,
    });
  };

  // const formatTimeForDisplay = (timeString) => {
  //   if (!timeString) return '';

  //   // Extract just the time part if it's a full datetime string
  //   const timePart = timeString.includes('T')
  //     ? timeString.split('T')[1]
  //     : timeString;

  //   // Remove seconds if present
  //   const [hours, minutes] = timePart.split(':');

  //   const hour = parseInt(hours, 10);
  //   const period = hour >= 12 ? 'PM' : 'AM';
  //   const hour12 = hour % 12 || 12;

  //   return `${hour12}:${minutes} ${period}`;
  // };


  const handleRoomType = (updatedOptions) => {
    debugger
    const selectedType = updatedOptions.value;

    // if no type selected, show empty or all rooms depending on UX
    if (!selectedType) {
      setFilteredRooms([]); // or setFilteredRooms(room) to show all
      // also clear selected room if any
      if (formFields.room) {
        setFormFields((prev) => ({ ...prev, room: null }));
      }
      return;
    }

    // ensure type comparison is consistent (string/number)
    const filtered = bindRoom.filter(
      (r) => String(r.typeId) == String(selectedType)
    );

    setFilteredRooms(filtered);

    // if current selected room is not in filtered list, clear it
    if (formFields.room && !filtered.some((r) => r.value === formFields.room)) {
      setFormFields((prev) => ({ ...prev, room: null }));
    }
  }


  return (
    <MainLayout pageName="2">
      {/* Loader */}
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />

      {/* Grid View */}
      {visibleTable && (
        <GridPage
          header={HouseKeepingHeader}
          title="House Keeping"
          records={bindHouseKeepingData.map((item) => ({
            ...item,
            InTime: formatTimeForDisplay(item.InTime),
            OutTime: formatTimeForDisplay(item.OutTime),
          }))}
          //records={bindHouseKeepingData}
          handleEdit={handleEdit}
          handleAction={handlePopupAction}
          showAdd={handleAddHouseKeepingClick}
          blockview={true}
        />
      )}
      {/* Add/Edit Form */}
      {visibleAdd && (
        <div className="w-full">
          <AddScreenTitle
            addScreenTitle={addScreenTitle}
            updateScreenTitle={updateScreenTitle}
            title="House Keeping"
          />
          {/* <div className="mx-auto mt-16 md:w-2/5 w-full flex items-center justify-center">
            <div className="relative w-full h-full max-w-xl md:h-auto">
              <div className="relative bg-white rounded-lg shadow">
                <div className="px-6 py-6 lg:px-8"> */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 p-4">
            <InputText
              inputType="text"
              title="House Keeping No"
              name="housekeepingEno"
              content={formFields.HouseKeepingNo}
              controlFunc={handleInputChange}
              controlFuncBlur={handleBlur}
              classStar="text-red-500"
              isRequired={true}
              errorMessage={errors.housekeepingEno}
              disabled={true}
            />
            <InputText
              inputType="date"
              title="Date"
              name="date"
              content={formFields.date}
              controlFunc={handleInputChangeForm}
              controlFuncBlur={handleBlur}
              classStar="text-red-500"
              errorMessage={errors.date}
              disabled={true}
            />
            <AutoDropDown
              name="roomType"
              title="Room Type"
              options={bindRoomType}
              selectedOption={bindRoomType.find((x) => x.value == formFields.roomType)}
              placeholder="Select Room Type"
              Class="custom-class"
              disabled={false}
              classStar="text-red-500"
              controlFunc={(option) => {
                handleAutoDropdownChange(option, "roomType");
                handleRoomType(option);
              }}

              errorMessage={errors.roomType}
            />

            <AutoDropDown
              name="room"
              title="Room"
              options={filteredRooms}
              placeholder="Select Room"
              selectedOption={filteredRooms.find((x) => x.value == formFields.room)}
              Class="custom-class"
              disabled={false}
              classStar="text-red-500"
              controlFunc={(option) => handleAutoDropdownChange(option, "room")}
              errorMessage={errors.room}
            />

            <AutoDropDown
              name="roomStatus"
              title="Room Status"
              options={BindRoomStatus}
              selectedOption={BindRoomStatus.find((x) => x.value == formFields.roomStatus)}
              placeholder="Select Room Status"
              Class="custom-class"
              disabled={false}
              classStar="text-red-500"
              controlFunc={(option) => handleAutoDropdownChange(option, "roomStatus")}
              errorMessage={errors.roomStatus}
            />
            <AutoDropDown
              name="employeeName"
              title="Employee Name"
              options={bindEmployeeName}
              selectedOption={bindEmployeeName.find(
                (x) => x.value === formFields.employeeName
              )}
              placeholder="Select Employee"
              Class="custom-class"
              disabled={false}
              classStar="text-red-500"
              controlFunc={(option) => handleAutoDropdownChange(option, "employeeName")}
              errorMessage={errors.employeeName}
            />
            <InputText
              inputType="text"
              title="Employee ID"
              name="employeeID"
              content={formFields.employeeID}
              controlFunc={handleInputChange}
              controlFuncBlur={handleBlur}
              classStar="text-red-500"
              isRequired={true}
              errorMessage={errors.employeeID}
              disabled={true}

            />


            <InputText
              inputType="text"
              title="Employee Position"
              name="employeePosition"
              content={formFields.employeePosition}
              controlFunc={handleInputChange}
              classStar="text-red-500"
              disabled={true}
            />
            <InputText
              inputType="time"
              title="In Time"
              name="inTime"
              content={formFields.inTime}
              controlFunc={handleInputChange}
              controlFuncBlur={handleBlur}
              classStar="text-red-500"
              disabled={false}
              isRequired={true}
              errorMessage={errors.inTime}
            />
            <InputText
              inputType="time"
              title="Out Time"
              name="outTime"
              content={formFields.outTime}
              controlFunc={handleInputChange}
              controlFuncBlur={handleBlur}
              classStar="text-red-500"
              disabled={false}
              isRequired={true}
              errorMessage={errors.outTime}
            />
        <div className="flex flex-col">
  <MultiSelect
    classStar="text-red-500"
    label="Maintenance Activity"
    filteredOptions={maintenanceDropdown}
    classFilterLabel="p-1 flex gap-1"
    class="custom-class"
    placeholder={
      formFields.txnMaintenanceActivityId?.length > 0
        ? "More Selected"
        : "Select..."
    }
    name="txnMaintenanceActivityId"
    selectedOptions={formFields.txnMaintenanceActivityId || []}
    classDiv="relative w-full inline-block"
    className={mainTable.maintenance}
    onChange={(selected) => {
      setFormFields((prev) => ({
        ...prev,
        txnMaintenanceActivityId: selected,
      }));
    }}
  />
  {errors.txnMaintenanceActivityId && (
    <p className="text-red-500 text-sm font-medium mt-1">
      {errors.txnMaintenanceActivityId}
    </p>
  )}
</div>
          </div>
          
          <div className="p-4">
            <TextArea
              title="Description"
              rows={3}
              name="description"
              content={formFields.description}
              resize={false}
              placeholder="Enter description"
              controlFunc={(e) =>
                setFormFields((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
              controlFuncBlur={() => { }}
              disabled={false}
              // tabIndex="0"
              errorMessage={errors.description}
            />
          </div>
          <div className="flex justify-center mt-6">
            <Buttons
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              viewSaveButton={false}
              disabledBtn={submitBtnDisabled || isLoading}
              handleSubmit={handleSubmit}
              cancel={cancel}
            />
            {/* </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      )}
      {/* Error Popup */}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}

      {/* Main Popup (View/Delete/Block/Unblock) */}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={() => setpopUpOpen(false)}
      >
        <div>
          <PopUpScreenTitle
            title="House Keeping"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <HouseKeepingPopup
            data={popUpData}
            data1={bindRoomType || []}
            bindEmployeeName={bindEmployeeName}
            data2={maintenanceDropdown}
          />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default HouseKeeping;
